function isMaxWidth(maxWidth) {
  const mediaQuery = `only screen and (max-width: ${maxWidth})`
  return window.matchMedia(mediaQuery).matches;
}

function isMinWidth(minWidth) {
  const mediaQuery = `only screen and (min-width: ${minWidth})`
  return window.matchMedia(mediaQuery).matches;
}

function isMobile() {
  return isMaxWidth("760px");
}

function isIpadPortrait() {
  return isMaxWidth("1024px");
}

export default { isMinWidth, isMaxWidth, isMobile, isIpadPortrait };
